<template>
<div class="chapter">
<div class="inner_page">
<a id="page_9"></a>
<p class="ded"><span class="Italic">This book is for anyone who has ever felt completely overwhelmed, stressed out, and burnt out. I hope this book provides a little boost to help you discover what the next small step forward i</span><span class="noBreak"><span class="Italic">s for you.</span></span></p>
<p class="ded1"><span class="Italic">Small steps add up, and you can figure th</span><span class="noBreak"><span class="Italic">ings out, </span></span><span class="Italic"> one small step </span><span class="noBreak"><span class="Italic">at a time.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?b52a7418